/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { ClientGoalDto, GetCriticalElementGoalsParams } from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getCriticalElementGoalById = (
  userId: string,
  criticalElementId: number,
  goalId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ClientGoalDto>(
    {
      url: `/api/${userId}/critical-elements/${criticalElementId}/goals/${goalId}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetCriticalElementGoalByIdQueryKey = (
  userId: string,
  criticalElementId: number,
  goalId: number
) => {
  return [
    `/api/${userId}/critical-elements/${criticalElementId}/goals/${goalId}`,
  ] as const;
};

export const getGetCriticalElementGoalByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCriticalElementGoalById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  goalId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementGoalById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCriticalElementGoalByIdQueryKey(userId, criticalElementId, goalId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCriticalElementGoalById>>
  > = ({ signal }) =>
    getCriticalElementGoalById(
      userId,
      criticalElementId,
      goalId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && criticalElementId && goalId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCriticalElementGoalById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCriticalElementGoalByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCriticalElementGoalById>>
>;
export type GetCriticalElementGoalByIdQueryError = ErrorType<unknown>;

export function useGetCriticalElementGoalById<
  TData = Awaited<ReturnType<typeof getCriticalElementGoalById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  goalId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementGoalById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCriticalElementGoalById>>,
          TError,
          Awaited<ReturnType<typeof getCriticalElementGoalById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCriticalElementGoalById<
  TData = Awaited<ReturnType<typeof getCriticalElementGoalById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  goalId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementGoalById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCriticalElementGoalById>>,
          TError,
          Awaited<ReturnType<typeof getCriticalElementGoalById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCriticalElementGoalById<
  TData = Awaited<ReturnType<typeof getCriticalElementGoalById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  goalId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementGoalById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCriticalElementGoalById<
  TData = Awaited<ReturnType<typeof getCriticalElementGoalById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  goalId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementGoalById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCriticalElementGoalByIdQueryOptions(
    userId,
    criticalElementId,
    goalId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />Assign goal to critical element
 */
export const assignGoalToCriticalElement = (
  userId: string,
  criticalElementId: number,
  goalId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ClientGoalDto>(
    {
      url: `/api/${userId}/critical-elements/${criticalElementId}/goals/${goalId}`,
      method: 'PUT',
      signal,
    },
    options
  );
};

export const getAssignGoalToCriticalElementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignGoalToCriticalElement>>,
    TError,
    { userId: string; criticalElementId: number; goalId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignGoalToCriticalElement>>,
  TError,
  { userId: string; criticalElementId: number; goalId: number },
  TContext
> => {
  const mutationKey = ['assignGoalToCriticalElement'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignGoalToCriticalElement>>,
    { userId: string; criticalElementId: number; goalId: number }
  > = (props) => {
    const { userId, criticalElementId, goalId } = props ?? {};

    return assignGoalToCriticalElement(
      userId,
      criticalElementId,
      goalId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignGoalToCriticalElementMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignGoalToCriticalElement>>
>;

export type AssignGoalToCriticalElementMutationError = ErrorType<unknown>;

export const useAssignGoalToCriticalElement = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof assignGoalToCriticalElement>>,
      TError,
      { userId: string; criticalElementId: number; goalId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof assignGoalToCriticalElement>>,
  TError,
  { userId: string; criticalElementId: number; goalId: number },
  TContext
> => {
  return useMutation(
    getAssignGoalToCriticalElementMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />Unassign goal from critical element
 */
export const unassignGoalFromCriticalElement = (
  userId: string,
  criticalElementId: number,
  goalId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/${userId}/critical-elements/${criticalElementId}/goals/${goalId}`,
      method: 'DELETE',
      signal,
    },
    options
  );
};

export const getUnassignGoalFromCriticalElementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unassignGoalFromCriticalElement>>,
    TError,
    { userId: string; criticalElementId: number; goalId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unassignGoalFromCriticalElement>>,
  TError,
  { userId: string; criticalElementId: number; goalId: number },
  TContext
> => {
  const mutationKey = ['unassignGoalFromCriticalElement'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unassignGoalFromCriticalElement>>,
    { userId: string; criticalElementId: number; goalId: number }
  > = (props) => {
    const { userId, criticalElementId, goalId } = props ?? {};

    return unassignGoalFromCriticalElement(
      userId,
      criticalElementId,
      goalId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UnassignGoalFromCriticalElementMutationResult = NonNullable<
  Awaited<ReturnType<typeof unassignGoalFromCriticalElement>>
>;

export type UnassignGoalFromCriticalElementMutationError = ErrorType<unknown>;

export const useUnassignGoalFromCriticalElement = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unassignGoalFromCriticalElement>>,
      TError,
      { userId: string; criticalElementId: number; goalId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof unassignGoalFromCriticalElement>>,
  TError,
  { userId: string; criticalElementId: number; goalId: number },
  TContext
> => {
  return useMutation(
    getUnassignGoalFromCriticalElementMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getCriticalElementGoals = (
  userId: string,
  criticalElementId: number,
  params?: GetCriticalElementGoalsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ClientGoalDto[]>(
    {
      url: `/api/${userId}/critical-elements/${criticalElementId}/goals`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetCriticalElementGoalsQueryKey = (
  userId: string,
  criticalElementId: number,
  params?: GetCriticalElementGoalsParams
) => {
  return [
    `/api/${userId}/critical-elements/${criticalElementId}/goals`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCriticalElementGoalsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCriticalElementGoals>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  params?: GetCriticalElementGoalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementGoals>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCriticalElementGoalsQueryKey(userId, criticalElementId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCriticalElementGoals>>
  > = ({ signal }) =>
    getCriticalElementGoals(
      userId,
      criticalElementId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && criticalElementId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCriticalElementGoals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCriticalElementGoalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCriticalElementGoals>>
>;
export type GetCriticalElementGoalsQueryError = ErrorType<unknown>;

export function useGetCriticalElementGoals<
  TData = Awaited<ReturnType<typeof getCriticalElementGoals>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  params: undefined | GetCriticalElementGoalsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementGoals>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCriticalElementGoals>>,
          TError,
          Awaited<ReturnType<typeof getCriticalElementGoals>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCriticalElementGoals<
  TData = Awaited<ReturnType<typeof getCriticalElementGoals>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  params?: GetCriticalElementGoalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementGoals>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCriticalElementGoals>>,
          TError,
          Awaited<ReturnType<typeof getCriticalElementGoals>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCriticalElementGoals<
  TData = Awaited<ReturnType<typeof getCriticalElementGoals>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  params?: GetCriticalElementGoalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementGoals>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCriticalElementGoals<
  TData = Awaited<ReturnType<typeof getCriticalElementGoals>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  criticalElementId: number,
  params?: GetCriticalElementGoalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalElementGoals>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCriticalElementGoalsQueryOptions(
    userId,
    criticalElementId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
